import { IAutoMapper } from "../interfaces";

export const mapLoadSummaryResponse = (automapper: IAutoMapper): void => {
  automapper
    .createMap("default", "LoadSummaryResponse")
    .forMember("tenantId", o => o.tenantId)
    .forMember("loadId", o => o.loadId)
    .forMember("submissionReadyCount", o => o.submissionReadyCount)
    .forMember("validationErrorCount", o => o.validationErrorCount)
    .forMember("validationWarningCount", o => o.validationWarningCount)
    .forMember("recordExistsCount", o => o.recordExistsCount)
    .forMember("submissionCount", o => o.submissionCount)
    .forMember("submissionFailedCount", o => o.submissionFailedCount)
    .forMember("totalCount", o => o.totalCount)
    .forMember("loadCreateTs", o => o.loadCreateTs);
};
